import { BaseLayoutConfig, BaseLayoutSection, BaseLayoutTab, BaseLayoutContext, DayOfWeek } from '../types/base-layout'
import { sanitizeHtmlContent } from './sanitize'

const DAYS: DayOfWeek[] = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']

function hydrateSection(section: BaseLayoutSection, context: BaseLayoutContext): BaseLayoutSection {
  if (section.type === 'textBox') {
    const safeContent = sanitizeHtmlContent(section.content ?? null) ?? ''

    return {
      ...section,
      content: safeContent,
    }
  }

  if (section.type === 'dailyMessage') {
    const optionDays = (section.options?.['days'] as Record<DayOfWeek, string | undefined>) ?? {}
    const merged = DAYS.reduce<Record<DayOfWeek, string>>((acc, day) => {
      const configured = optionDays[day]
      const fallback = context.dailyMessages?.[day]
      acc[day] = sanitizeHtmlContent(configured ?? fallback ?? null) ?? ''
      return acc
    }, {
      sunday: '',
      monday: '',
      tuesday: '',
      wednesday: '',
      thursday: '',
      friday: '',
      saturday: '',
    })

    return {
      ...section,
      options: {
        ...section.options,
        days: merged,
      },
    }
  }

  return section
}

export function hydrateLayoutWithContext(layout: BaseLayoutConfig, context: BaseLayoutContext): BaseLayoutConfig {
  return {
    version: layout.version,
    tabs: layout.tabs.map<BaseLayoutTab>((tab) => ({
      ...tab,
      sections: tab.sections.map((section) => hydrateSection(section, context)),
    })),
  }
}
